import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StepStyleContainer } from '../@shared/step-style-container';
import { Button } from '@components/Common';
import { useWatchSteamSettings } from 'core/User';
import { SteamBinding } from '../../icons';

export const SteamGuardStep = () => {
  const { t } = useTranslation('steam-settings');
  const { handleOpenSettings } = useWatchSteamSettings();
  return (
    <Container>
      <div className="step-header">
        <h5 className="step-header-title">{t('Connect Steam Guard')}</h5>
        <div className="step-header-warning-message">
          <i className="icon-warn" />
          <p>
            {t(
              'Connecting the Steam Guard Mobile Authenticator to your Steam account for the first time may take time This is necessary to ensure the security of your Steam account'
            )}
          </p>
        </div>
      </div>
      <Button
        className="steam-provider"
        onClick={handleOpenSettings(
          'https://support.steampowered.com/kb_article.php?ref=4440-rtui-9218'
        )}
      >
        <SteamBinding />
        {t('Connect Steam Guard')}
        <i className="icon-redirect-link" />
      </Button>
    </Container>
  );
};

const Container = styled(StepStyleContainer)``;
